import { useIntersectionObserver } from '#/shared/lib/hooks'
import { Skeleton } from '#/shared/ui/skeleton'

interface FeedAutoLoaderProps {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

export function FeedAutoLoader({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: FeedAutoLoaderProps) {
  const setNode = useIntersectionObserver({
    enabled: hasNextPage && !isFetchingNextPage,
    rootMargin: '160px',
    onIntersect: onLoadMore,
  })

  if (!hasNextPage) return null

  return (
    <div ref={setNode}>
      {isFetchingNextPage ? (
        <div className="flex h-9 items-center gap-2.5 rounded-md bg-white px-2.5">
          <Skeleton className="size-5 shrink-0 rounded-full" />
          <Skeleton className="h-4 flex-1" />
          <Skeleton className="h-3 w-24 shrink-0" />
        </div>
      ) : (
        <div className="h-1 w-full" />
      )}
    </div>
  )
}
